<template>
    <section id="start-with-us center" v-if="show">
        <div class='welcome-container'>
       
            <h2>
                {{ $t("components.start_with_us.title") }}
            </h2>

            <p>
                {{ $t("components.start_with_us.label_line_one") }}
            </p>

            <router-link :to="{ name: 'flow-subscribed' }" v-if="$root.source !== 'bennet'">
                <CTA
                    :content="$t('components.start_with_us.button')"
                    isArrow
                />
            </router-link> 

            <CTA
                v-else
                :content="$root.source === 'bennet' ? 'Scegli la tua box' : 'Scegli il tuo piano'"
                isArrowUp
                @click="$emit('scroll-to-div')"
            />               

            <feedaty
                isSmall
                :uid="2"
            />

            <div class=" mt-5" v-if="$root.source === 'bennet'">
                <span class="text-bold" style="color: var(--quomi-flyer)">Powered by</span>
                <img class="pb-1" src="https://api.quomi.it/oldimg/Logo-Quomi-noback.webp" alt="logo-quomi" style="width: 25%">
            </div>
        </div>
    </section>
</template>

<script>

import Feedaty from '../Feedaty'
import CTA from '../Elements/CTA'
export default {
	components: {
		Feedaty,
        CTA
	},

    computed: {
        show () {
            return !(this.$root.$data.user && this.$root.$data.user.isSubscribed())
        }
    }
}

</script>

<style scoped>
    section {
        padding-bottom: 0;
    }

    .welcome-container {
        min-height: 275px;
        display: flex;
        align-items: center;
        text-align: center;
        flex-flow: column;
        justify-content: center;
        background-color: #EDEDED;
        padding: 0 10px;
    }

    @media(max-width: 640px){
    .welcome-container {
        justify-content: unset;
        padding-top: 2rem;
    }
    }

</style>
